"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _reactSvg = require("react-svg");
var _Anchor = _interopRequireDefault(require("../../Atoms/Anchor"));
var _L1NavItem = _interopRequireDefault(require("./L1NavItem"));
var _V2NavL1Item = _interopRequireDefault(require("./V2NavBar/V2NavL1Item"));
var _screenSizes = _interopRequireDefault(require("../../../core/utils/screenSizes"));
var _navUtils = require("./nav-utils");
var _mobileNavListItems = _interopRequireDefault(require("./V2MoblieNavBar/mobileNavListItems"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var NavBar = function NavBar(props) {
  var data = props.data,
    className = props.className,
    handleNavigationDrawer = props.handleNavigationDrawer,
    hovered = props.hovered,
    isMobile = props.isMobile,
    config = props.config,
    showDropdown = props.showDropdown,
    labels = props.labels,
    quickOrderUrl = props.quickOrderUrl,
    isHideQuickOrderLink = props.isHideQuickOrderLink,
    isNavigationV2Enabled = props.isNavigationV2Enabled,
    _props$mobileData = props.mobileData,
    mobileData = _props$mobileData === void 0 ? {} : _props$mobileData,
    _props$mobileV2Config = props.mobileV2Config,
    mobileV2Config = _props$mobileV2Config === void 0 ? {} : _props$mobileV2Config;
  var _useState = (0, _react.useState)(false),
    isResize = _useState[0],
    setIsResize = _useState[1];
  var headerTB = document.querySelector('header.page-header  .top-bar');
  var headerNavigation_mainUL = document.querySelector('.cmp-header__navigation nav.cmp-navigation');
  var headerNavigationMobileMainUL = document.querySelector('.cmp-header__navigation-mobile');
  var resizeMobileViewScroll = function resizeMobileViewScroll() {
    if (headerNavigationMobileMainUL && headerNavigation_mainUL) {
      headerNavigationMobileMainUL.style.height = window.innerHeight - headerTB.offsetHeight + 'px';
      headerNavigation_mainUL.children[0].style.height = 'auto';
    }
  };
  (0, _react.useEffect)(function () {
    if (_screenSizes.default.isMobile() && !isResize && headerNavigationMobileMainUL) {
      window.addEventListener('resize', resizeMobileViewScroll());
      setIsResize(true);
    }
  });
  (0, _react.useEffect)(function () {
    window.addEventListener('resize', _navUtils.addL1Scroll);
    return function () {
      window.removeEventListener('resize', _navUtils.addL1Scroll);
    };
  }, []);
  (0, _react.useEffect)(function () {
    return function () {
      window.addEventListener('resize', resizeMobileViewScroll());
    };
  });
  var getV2NavigationComponent = function getV2NavigationComponent() {
    return _screenSizes.default.isTabletAndOver() ? Array.isArray(data) && data.map(function (navV2L1Item, index) {
      var navL1Key = "nav-l1-" + index;
      return _react.default.createElement(_V2NavL1Item.default, (0, _extends2.default)({
        className: "cmp-navigation__item",
        config: config,
        dataLocator: "nav-" + navV2L1Item.title,
        hasL2: !!navV2L1Item.xfData,
        handleNavigationDrawer: handleNavigationDrawer,
        navL1Item: navV2L1Item,
        key: navL1Key,
        xfNavHtml: navV2L1Item.xfData
      }, props));
    }) : _react.default.createElement("div", {
      className: "cmp-header__navigation-mobile"
    }, _react.default.createElement(_mobileNavListItems.default, (0, _extends2.default)({
      mobileData: mobileData
    }, mobileV2Config)));
  };
  var isMobileActive = hovered && isMobile ? 'is-expanded' : '';
  return _react.default.createElement("ul", {
    id: "cmp-navigation__ul_group",
    className: className + " cmp-navigation__group " + isMobileActive,
    role: "menubar",
    onScroll: _navUtils.addL1Scroll,
    onMouseLeave: _navUtils.removeL1Scroll
  }, !isHideQuickOrderLink && !isNavigationV2Enabled && _react.default.createElement("li", {
    className: "cmp-navigation__item cmp-navigation__item--level-" + 0 + " " + isMobileActive + " quick-order-navigation",
    role: "menuitem"
  }, _react.default.createElement("div", {
    className: "cmp-navigation__container",
    "data-locator": "mobile-quick-order"
  }, _react.default.createElement(_Anchor.default, {
    className: "cmp-navigation__item-link quick-order-link",
    to: quickOrderUrl,
    as: quickOrderUrl,
    title: labels.quickOrder,
    "aria-label": labels.quickOrder,
    elementLocator: "quick-order-link"
  }, labels.quickOrder, _react.default.createElement(_reactSvg.ReactSVG, {
    src: config.addItemsToCart
  })))), isNavigationV2Enabled ? getV2NavigationComponent() : Array.isArray(data) && data.map(function (navL1Item, index) {
    var l1Key = "l1-nav-" + index;
    return _react.default.createElement(_L1NavItem.default, (0, _extends2.default)({
      className: "cmp-navigation__item",
      config: config,
      showDropdown: showDropdown,
      dataLocator: "nav-" + navL1Item.title,
      hasL2: navL1Item.children.length > 0,
      handleNavigationDrawer: handleNavigationDrawer,
      navL1Item: navL1Item,
      key: l1Key
    }, props));
  }));
};
NavBar.defaultProps = {
  hovered: false,
  isMobile: false,
  isDesktop: true,
  showDropdown: false,
  config: {},
  quickOrderUrl: '/#',
  isHideQuickOrderLink: false
};
var _default = NavBar;
exports.default = _default;
module.exports = exports["default"];